<template>
  <div>
    <div class="text-h6">
      Check your notifications on another device
    </div>
    <p>
      Go to your Facebook account on another device
      and open the notification we sent to approve this login.
    </p>
    <q-linear-progress indeterminate class="q-my-md" />
    <p class="text-bold">Waiting for approval</p>
    <p>It may take a few minutes to get the notification on your other device.</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { getStatus, LoginResult, wasSuccess } from '.';

export default defineComponent({
  emits: ['result'],
  props: {
    sessionId: {
      type: String,
      required: true,
    },
    result: {
      type: Object as () => LoginResult,
      required: true,
    },
  },
  watch: {
    sessionId: {
      handler() {
        this.keepChecking();
      },
      immediate: true,
    },
  },
  methods: {
    keepChecking() {
      const check = async () => {
        const result = await getStatus(this.sessionId);
        this.$emit('result', result);
        if (result.mfa && result.mfa.type === 'other_device') {
          setTimeout(check, 5000);
        }
      };
      check();
    },
  },
});
</script>
